var _circle, _path, _path2, _rect, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllTeamsMakePlayoffs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    stroke: "#103B5D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0977 59.5H49.0977C49.9261 59.5 50.5977 60.1716 50.5977 61V65.5H28.5977V61C28.5977 60.1716 29.2692 59.5 30.0977 59.5Z",
    fill: "#103B5D",
    stroke: "#103B5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0977 54.5H45.0977C45.9261 54.5 46.5977 55.1716 46.5977 56V59.5H32.5977V56C32.5977 55.1716 33.2692 54.5 34.0977 54.5Z",
    fill: "#103B5D",
    stroke: "#103B5D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.5977,
    y: 45.5,
    width: 4,
    height: 9,
    fill: "#103B5D",
    stroke: "#103B5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5219 15.5H51.6734C52.6162 15.5 53.3253 16.3594 53.1461 17.285L49.222 37.5599C48.3297 42.1701 44.2934 45.5 39.5977 45.5C34.9019 45.5 30.8657 42.1701 29.9734 37.5599L26.0492 17.285C25.8701 16.3594 26.5791 15.5 27.5219 15.5Z",
    fill: "#103B5D",
    stroke: "#103B5D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3748 34.4797C25.282 34.208 21.8311 31.2371 20.9915 27.1713L19.8954 21.8634C19.75 21.1597 20.2874 20.5 21.0059 20.5H26.5898L29.3748 34.4797Z",
    stroke: "#103B5D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8165 34.4798L52.5105 20.5H58.1164C58.8258 20.5 59.3579 21.1491 59.2188 21.8447L58.1548 27.1645C57.3419 31.2292 53.9026 34.2086 49.8165 34.4798Z",
    stroke: "#103B5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllTeamsMakePlayoffs);
export default __webpack_public_path__ + "static/media/all_teams_make_playoffs.941fb265e8198fe2121cc40a6f2cfdf4.svg";
export { ForwardRef as ReactComponent };